import { render, staticRenderFns } from "./usuarios.vue?vue&type=template&id=ed853698"
import script from "./usuarios.vue?vue&type=script&lang=js"
export * from "./usuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports